<div id="container" class="p-col surveyQuestions">
  <div style="margin-bottom: 40px">
    <h3 class="sectionTitleHeader">{{ 'Thank you for your participation in the competition' | translate }}</h3>
  </div>
</div>